import axios from 'axios';
import clone from 'lodash.clonedeep';

import { EVISIT_STATUS, DASHBOARD_PAGE_SIZE } from '../../../config/constants';

const ENDED_FILTER = {
	where: {
		and: [
			{
				end_dttm: {
					neq: null,
				},
			},
			{
				start_dttm: {
					neq: null,
				},
			},
			{
				evisit_status: {
					nin: [EVISIT_STATUS.CANCELLED, EVISIT_STATUS.CANCELLED_APPOINTMENT],
				},
			},
		],
	},
	include: ['patient_dependent', 'patient', 'provider_visit_type'],
	order: ['start_dttm DESC'],
};

export const getPracticePanel = async (practiceId) => {
	const { data } = await axios.get(
		`/provider_practices/${practiceId}/practice-panel`
	);
	return data;
};

export const getEnded = ({
	providerPracticeId,
	page = 1,
	providerId,
	patientId,
}) => {
	var skip = (page - 1) * DASHBOARD_PAGE_SIZE;

	const filter = clone(ENDED_FILTER);
	filter.limit = DASHBOARD_PAGE_SIZE;
	filter.skip = skip;
	filter.where.and.push({ providerPracticeId });
	if (providerId) {
		filter.where.and.push({ providerId });
	}
	if (patientId) {
		filter.where.and.push({ patientId });
	}

	return axios.get(`/provider_practices/${providerPracticeId}/evisits`, {
		params: { filter: JSON.stringify(filter) },
	});
};

export const getEndedCount = ({
	providerPracticeId,
	providerId,
	patientId,
}) => {
	const filter = clone(ENDED_FILTER);
	filter.where.and.push({ providerPracticeId });
	if (providerId) {
		filter.where.and.push({ providerId });
	}
	if (patientId) {
		filter.where.and.push({ patientId });
	}
	filter.fields = { id: true };

	// don't need include data for count
	delete filter.include;

	return axios.get(`/provider_practices/${providerPracticeId}/evisits`, {
		params: { filter: JSON.stringify(filter) },
	});
};
